import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-core-offcanvas',
  templateUrl: './core-offcanvas.component.html',
  styleUrl: './core-offcanvas.component.scss',
})
export class CoreOffcanvasComponent implements OnChanges {

  @Input() saveText: string = '';
  @Output() closed = new EventEmitter();
  @Output() chooseOn = new EventEmitter();
  @Input() showFooter: boolean = true;
  @Input() showSaveButton: boolean = true;
  @Input() position: 'left' | 'right' | 'top' | 'bottom' = 'right'; // Sidebar pozisyonu
  @Input() width: string = '40%'; // Sidebar genişliği, varsayılan %40
  @Input() headerTitle: string = '';
  @Input() fullScreen: boolean = false;
  @Input() saveButtonDisable: boolean = false;
  isOpen: boolean = false;
  @Input() showThirdButton:boolean=false;
  @Input() thirdButtonText: string = '';
  @Output() chooseThirdButton = new EventEmitter();

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  openPopup() {
    this.isOpen = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['width'] && changes['width']?.firstChange == false) {
      this.width = changes['width']?.currentValue;
      this.isOpen = false;
      // setTimeout(() => {
      //   this.isOpen = true;
      // }, 200);
      this.cdr.detectChanges()
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth <= 480) {
      this.width = '90vw'; // Small screen width
    }
  }

  closePopup() {
    this.closed.emit();
    this.isOpen = false;

  }

  save() {
    this.chooseOn.emit();
  }

  onPressThirdButton(){
    this.chooseThirdButton.emit();
  }
}
